import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { retry, timeout } from 'rxjs/operators';
import { environment } from '@unico-people/benefits-dashboard/enviroment';
import { CallbackService } from '../../services/callback/callback.service';
import { AuthService } from '@unico-people/shared/dashboard/data-access-auth';
import { SessionStorage, setTokenStorage } from '@unico-people/shared/utils/storage';

declare const userGuiding;

@Component({
  selector: 'up-employee-callback',
  templateUrl: './employee-callback.component.html',
  styleUrls: ['./employee-callback.component.scss']
})
export class EmployeeCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private callbackService: CallbackService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.getToken(params.code);
    });
  }

  getToken(code: string): void {
    this.callbackService
      .getToken(code)
      .pipe(timeout(6000), retry(7))
      .subscribe(
        response => {
          const { token } = response;
          setTokenStorage(token);
          this.getAuthorization(token);
        },
        () => this.authService.logout(this.route?.snapshot?.data?.roles)
      );
  }

  getAuthorization(token: string): void {
    this.callbackService
      .getAuthorization(token)
      .pipe(timeout(6000), retry(7))
      .subscribe(
        response => {
          const { name, email, id, organization, organizationName } = response;

          SessionStorage.setItem('user', {
            user_name: name,
            user_email: email,
            user_id: id
          });

          isProductionSendUserIdentity(id, email, organizationName);
          SessionStorage.setItem('organization', organization);
          SessionStorage.setItem('organizationName', organizationName);
          this.router.navigate(['/']);
        },
        () => this.authService.logout(this.route?.snapshot?.data?.roles)
      );
  }
}

function isProductionSendUserIdentity(id: string, email: string, organizationName: string) {
  if (environment.production) {
    userGuiding.identify(id, { email: email, Organization: organizationName, Product: 'unico | people', User: 'RH', Module: 'ongoing' });
  }
}
